import { CSSObjectWithLabel } from 'react-select';

export const defaultSelectStyle = ( isOpen: boolean, disabled: boolean ): CSSObjectWithLabel  => {
  return {
    borderRadius: '8px',
    borderWidth: '0',
    outline: 'solid',
    outlineColor: ( isOpen ? '#847D7D' : '#D9D9D9' ),
    outlineWidth: ( isOpen ? '2px' : '1px' ),
    backgroundColor: ( isOpen ? '#FAF9F6' : ( disabled ? '#f5f5f4' : '#FFFFFF' ) ),
    alignItems: 'center',
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: '38px',
    position: 'relative',
    transition: 'all 100ms',
    boxSizing: 'border-box',
    ':hover': {
      outlineColor: '#847D7D',
      backgroundColor: '#FAF9F6'
    }
  };
};

export const DEFAULT_STEP = 40;

export const AVAILABLE_STEPS = [
  { value: 10, label: 10 },
  { value: 20, label: 20 },
  { value: 30, label: 30 },
  { value: DEFAULT_STEP, label: DEFAULT_STEP },
  { value: 50, label: 50 },
  { value: 75, label: 75 },
  { value: 100, label: 100 },
  { value: 200, label: 200 },
  { value: 400, label: 400 }
];

export const ORDINALS = [
  '',
  'first',
  'second',
  'third',
  'fourth',
  'fifth'
];
